import React, { useEffect } from "react"

// แถบแจ้งเตือนว่ากำลังใช้งานระบบทดสอบ ไม่ใช่ระบบจริง
//
// เปิด/ปิดจาก client/.env:
//   REACT_APP_ENV_BANNER = ระบบทดสอบ — ข้อมูลไม่ใช่ของจริง
//   REACT_APP_ENV_BANNER_COLOR = #d97706        (ไม่ใส่ก็ได้)
//
// ถ้าไม่ตั้งค่า REACT_APP_ENV_BANNER หรือปล่อยว่าง จะไม่ render อะไรเลย
// (prod จึงไม่ได้รับผลกระทบโดยไม่ต้องแก้โค้ด)
//
// หมายเหตุ: CRA ฝังค่า REACT_APP_* ตอน build ไม่ใช่ตอน runtime
// แก้ .env แล้วต้อง npm run build ใหม่เสมอ

const LABEL = (process.env.REACT_APP_ENV_BANNER || "").trim()
const COLOR = (process.env.REACT_APP_ENV_BANNER_COLOR || "#d97706").trim()

const wrapStyle = {
  position: "fixed",
  bottom: "12px",
  right: "12px",
  zIndex: 20000,
  pointerEvents: "none", // ไม่บังการคลิกใด ๆ
  display: "flex",
  alignItems: "center",
  gap: "8px",
  maxWidth: "calc(100vw - 24px)",
  padding: "7px 14px",
  borderRadius: "999px",
  background: COLOR,
  color: "#fff",
  fontSize: "13px",
  fontWeight: 600,
  lineHeight: 1.3,
  letterSpacing: "0.2px",
  boxShadow: "0 4px 14px rgba(0,0,0,.28)",
  userSelect: "none",
}

const dotStyle = {
  width: "8px",
  height: "8px",
  borderRadius: "50%",
  background: "#fff",
  opacity: 0.9,
  flexShrink: 0,
}

export default function EnvBanner() {
  useEffect(() => {
    if (!LABEL) return
    const original = document.title
    document.title = `[TEST] ${original}`
    return () => { document.title = original }
  }, [])

  if (!LABEL) return null

  return (
    <div style={wrapStyle} role="status" aria-live="polite">
      <span style={dotStyle} />
      <span>{LABEL}</span>
    </div>
  )
}
